import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function FamilyEditorial({ editorial, guide }) {
  if (!editorial && !guide) return null;
  if (!editorial) {
    return (
      <section className="mt-6 border-t pt-6" data-testid="family-guide-link-only">
        <a
          href={guide.url}
          className="text-sm font-semibold underline hover:no-underline"
          data-testid="family-guide-link"
        >
          {guide.selection_heading || `How to choose ${guide.h1.toLowerCase()}`} →
        </a>
      </section>
    );
  }
  return (
    <section className="max-w-[1320px] mx-auto px-4 sm:px-6 py-12 border-t border-[#E8E8E8]" data-testid="family-editorial">
      <h2 className="text-base md:text-lg font-bold uppercase tracking-[0.16em] mb-5" data-testid="family-editorial-h2">
        {editorial.h1}
      </h2>
      <p className="text-base leading-relaxed text-[#333] max-w-4xl" data-testid="family-editorial-intro">
        {editorial.intro}
      </p>
      <div className="grid md:grid-cols-2 gap-x-14 gap-y-7 mt-10" data-testid="family-editorial-sections">
        {(editorial.sections || []).map(([heading, body]) => (
          <div key={heading}>
            <p className="font-semibold mb-1">{heading}</p>
            <p className="text-sm leading-relaxed text-[#555]">{body}</p>
          </div>
        ))}
      </div>
      {guide && (
        <p className="mt-6 text-sm">
          <a href={guide.url} className="font-semibold underline hover:no-underline" data-testid="family-guide-link">
            {guide.selection_heading || `How to choose ${guide.h1.toLowerCase()}`} →
          </a>
        </p>
      )}
      {editorial.caution && (
        <p className="mt-10 flex gap-3 text-sm text-[#7a5d00] bg-[#FFF8E1] border border-[#F0E0A0] px-4 py-3 max-w-4xl" data-testid="family-editorial-caution">
          <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <span>{editorial.caution}</span>
        </p>
      )}
    </section>
  );
}

export default FamilyEditorial;
